'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var magicMessages = require('@gig/magic-messages');

function getMailCheckFeatureEnabled() {
    var _a;
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magicMessages.FEATURE_QUERY_ENABLED, magicMessages.Feature.MAIL_CHECK)];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : false)];
            }
        });
    });
}
function getUnmaskPasswordFeature() {
    var _a;
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magicMessages.FEATURE_QUERY_ENABLED, magicMessages.Feature.UNMASK_PASSWORD)];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : false)];
            }
        });
    });
}
function getAmendDobHintFeature() {
    var _a;
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magicMessages.FEATURE_QUERY_ENABLED, magicMessages.Feature.AMEND_DOB_HINT)];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : false)];
            }
        });
    });
}
function getCollapsibleMarketingPreferencesFeature() {
    var _a;
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magicMessages.FEATURE_QUERY_ENABLED, magicMessages.Feature.COLLAPSIBLE_MARKETING_PREFERENCES)];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : false)];
            }
        });
    });
}

exports.getAmendDobHintFeature = getAmendDobHintFeature;
exports.getCollapsibleMarketingPreferencesFeature = getCollapsibleMarketingPreferencesFeature;
exports.getMailCheckFeatureEnabled = getMailCheckFeatureEnabled;
exports.getUnmaskPasswordFeature = getUnmaskPasswordFeature;
